module.exports = __webpack_public_path__ + "static/img/logo02.14956f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/home/logo/logo02.jpg
// module id = u/1s
// module chunks = 1